import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function FloatingSocialCapsule() {
  const {
    t
  } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);
  const socialLinks = [{
    name: 'Instagram',
    url: 'https://instagram.com/thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-179" data-mp="2z33v7k7bbj0g">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-180" data-mp="2pedltn9y0srf" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-181" data-mp="2lcimupfhirgt" />
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-182" data-mp="2la5tzh86uwoz" />
        </svg>
  }, {
    name: 'TikTok',
    url: 'https://tiktok.com/@thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-183" data-mp="2bekym1xmkuo7">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-184" data-mp="33yjnty6mitz4" />
        </svg>
  }, {
    name: 'LinkedIn',
    url: 'https://linkedin.com/company/thisisneurospice',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-185" data-mp="3nnu2d8umv8vn">
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-186" data-mp="3io97b9il3ko7" />
          <rect x="2" y="9" width="4" height="12" data-id="element-187" data-mp="22a96zxfttt0f" />
          <circle cx="4" cy="4" r="2" data-id="element-188" data-mp="228eloi0n7yvt" />
        </svg>
  }];
  return <motion.div className="hidden lg:block fixed bottom-8 left-8 z-30" onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)} initial={false} data-id="element-189" data-mp="27a3wbwjyeajd">
      <AnimatePresence mode="wait" data-id="element-190" data-mp="1j6fhobe83nbw">
        {!isExpanded ? <motion.div key="collapsed" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className="bg-black text-white px-5 py-2.5 rounded-full border-2 border-white shadow-2xl cursor-pointer hover:bg-gray-900 transition-colors" data-id="element-191" data-mp="1eee9b0k6egr5">
            <div className="flex items-center gap-2 font-bold text-xs uppercase tracking-wider whitespace-nowrap" data-id="element-192" data-mp="qi9uzj3lzo9f">
              <span data-id="element-193" data-mp="2prqh1mj23jil">🧠</span>
              <span data-id="element-194" data-mp="2kuzpo31sx1hv">{t('floating.text')}</span>
            </div>
          </motion.div> : <motion.div key="expanded" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className="bg-black text-white p-6 rounded-2xl border-2 border-white shadow-2xl" data-id="element-195" data-mp="2seiqlob03feq">
            <div className="text-center mb-4" data-id="element-196" data-mp="2eegdefdn1a5t">
              <p className="font-black text-lg uppercase tracking-tight mb-1" data-id="element-197" data-mp="2ef9b6qumcpbt">
                {t('floating.text')}
              </p>
              <p className="text-xs text-gray-400 font-mono" data-id="element-198" data-mp="2jfnlkfjp0bd0">
                {t('social.handle')}
              </p>
            </div>
            <div className="flex gap-4 justify-center" data-id="element-199" data-mp="3ut98du22y0vd">
              {socialLinks.map(social => <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="w-12 h-12 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition-all duration-200 hover:scale-110" aria-label={social.name} data-id="element-200" data-mp="2odzkn1r4s5n">
                  {social.icon}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}